'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const isDocument = (el) => el.nodeType === Node.DOCUMENT_NODE;
function getDocument(el) {
  if (isDocument(el))
    return el;
  return el?.ownerDocument ?? document;
}
function getWindow(el) {
  return el?.ownerDocument.defaultView ?? window;
}

exports.getDocument = getDocument;
exports.getWindow = getWindow;
